import { UserProfile } from '../model/user-profile';
import { USERS } from './users';

export const USER_PROFILES = USERS.reduce((acc: UserProfile[], user) => {
  acc.push({
    id: user.id,
    user: user,
    timezone: 'GMT+3',
    // accountName: user.fullName,
    // affiliatedStores: getRandomItem(STORES).name,
  });

  return acc;
}, []);
